export default "__VITE_ASSET__3nA__AUd__"